var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-info-row"},[_c('span',{staticClass:"v-info-row__label"},[_vm._t("label")],2),_c('span',{staticClass:"v-info-row__value"},[_vm._t("value",function(){return [_vm._v("-")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }